// extracted by mini-css-extract-plugin
export default {"date":"PeriodPopoutHeader_date__kcdR7"};